import { render } from "./soal_salah_benar.vue?vue&type=template&id=0c73c1ce&scoped=true"
import script from "./soal_salah_benar.vue?vue&type=script&lang=js"
export * from "./soal_salah_benar.vue?vue&type=script&lang=js"

import "./soal_salah_benar.vue?vue&type=style&index=0&id=0c73c1ce&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c73c1ce"]])

export default __exports__